import { create } from "zustand";
import { subWeeks } from "date-fns";
import { DatePickerRange } from "./tables";

interface TableDataRangeState {
  dateRange: DatePickerRange;
  setDateRange: (range: DatePickerRange) => void;
}

export const useTableDataRangeStore = create<TableDataRangeState>((set) => ({
  dateRange: {
    from: subWeeks(new Date(), 1),
    to: new Date(),
  },
  setDateRange: (range) =>
    set({
      dateRange: range,
    }),
}));
